import React from "react";
import { FiSearch, FiLayout, FiEdit3, FiSmartphone } from "react-icons/fi";
import { Container, H2_SIZE, H3_SIZE } from "../home/ui";

const services = [
  {
    icon: FiSearch,
    title: "User Research",
    text: "Understand your users, their needs and business goals with in-depth research.",
    items: ["User Interviews", "Competitor Analysis", "User Personas"],
    iconBox: "bg-[#FFE4EC] text-[#EC4899]",
    accent: "from-[#F472B6]",
    bullet: "text-[#A855F7]",
  },
  {
    icon: FiLayout,
    title: "UX Strategy",
    text: "Define the right strategy to create meaningful and usable products.",
    items: ["Information Architecture", "User Journey Mapping", "Wireframing"],
    iconBox: "bg-[#E3EDFF] text-[#2563EB]",
    accent: "from-[#60A5FA]",
    bullet: "text-[#3D5BF6]",
  },
  {
    icon: FiEdit3,
    title: "UI Design",
    text: "Modern, clean and visually appealing interfaces that engage users.",
    items: ["High-Fidelity Designs", "Design System", "Brand Consistency"],
    iconBox: "bg-[#EEE6FF] text-[#7C3AED]",
    accent: "from-[#A78BFA]",
    bullet: "text-[#3D5BF6]",
  },
  {
    icon: FiSmartphone,
    title: "Prototyping & Testing",
    text: "Interactive prototypes and usability testing to validate your product.",
    items: ["Interactive Prototypes", "Usability Testing", "Iterative Improvements"],
    iconBox: "bg-[#DFF7EC] text-[#10B981]",
    accent: "from-[#34D399]",
    bullet: "text-[#14B8A6]",
  },
];

// Four-point sparkle used as the list bullet in the reference design.
const Sparkle = ({ className = "" }) => (
  <svg viewBox="0 0 12 12" className={`h-[10px] w-[10px] shrink-0 fill-current ${className}`} aria-hidden="true">
    <path d="M6 0c.4 2.9 1.9 4.6 6 6-4.1 1.4-5.6 3.1-6 6-.4-2.9-1.9-4.6-6-6 4.1-1.4 5.6-3.1 6-6z" />
  </svg>
);

const UiuxServices = () => (
  <section className="relative overflow-hidden bg-white py-[48px] lg:py-[68px]">
    <span className="pointer-events-none absolute -right-[120px] -top-[120px] h-[300px] w-[300px] rounded-full bg-[#EEEBFF] opacity-70" />

    <Container className="relative max-w-[1320px]">
      <div className="text-center">
        <span className="inline-block rounded-full bg-[#ECEBFF] px-[16px] py-[5px] text-[12px] font-semibold uppercase tracking-[0.04em] text-[#3B2A8F]">
          Our Services
        </span>
        <h2 className={`mt-[14px] font-extrabold tracking-tight text-[#0B0D2C] ${H2_SIZE}`}>
          End-to-End UI/UX Design Services
        </h2>
        <p className="mx-auto mt-[12px] max-w-[640px] text-[15px] leading-[1.6] text-slate-600 sm:text-[16px]">
          From research to final design, we cover everything to build exceptional digital experiences.
        </p>
      </div>

      <div className="m-swipe mt-[36px] grid gap-[20px] sm:grid-cols-2 xl:grid-cols-4">
        {services.map((s) => (
          <div
            key={s.title}
            className="relative overflow-hidden rounded-[20px] border border-solid border-[#EEF0F7] bg-white p-[24px] shadow-[0_14px_36px_-24px_rgba(40,60,140,0.35)] transition hover:-translate-y-1"
          >
            <span className={`absolute left-0 top-0 h-[3px] w-[55%] bg-gradient-to-r to-transparent ${s.accent}`} />
            <span className={`inline-flex h-[64px] w-[64px] items-center justify-center rounded-[16px] text-[28px] ${s.iconBox}`}>
              <s.icon />
            </span>
            <h3 className={`mt-[20px] font-bold text-[#0B0D2C] ${H3_SIZE}`}>{s.title}</h3>
            <p className="mt-[8px] text-[14px] leading-[1.55] text-slate-600">{s.text}</p>
            <ul className="mt-[18px] space-y-[10px] p-0">
              {s.items.map((item) => (
                <li key={item} className="flex list-none items-center gap-[12px] text-[14px] text-slate-600">
                  <Sparkle className={s.bullet} />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </Container>
  </section>
);

export default UiuxServices;
